import Vue from 'vue'
import help from './help.vue'

const HelpBox = Vue.extend(help);

let Help = (text, title = '提示', options) => {
  if (typeof title === 'object') {
    options = title;
    title = '';
  } else if (title === undefined) {
    title = '';
  }

  options = Object.assign({
    title: title,
    text: text
  }, options);

  let instance = new HelpBox({
    data: options
  }).$mount();

  document.body.appendChild(instance.$el);

  return instance.confirm();
};

export default Help;
